/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDeliveryParcels200ResponseAllOfData } from './GetDeliveryParcels200ResponseAllOfData';
import {
    GetDeliveryParcels200ResponseAllOfDataFromJSON,
    GetDeliveryParcels200ResponseAllOfDataFromJSONTyped,
    GetDeliveryParcels200ResponseAllOfDataToJSON,
} from './GetDeliveryParcels200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetDeliveryParcels200Response
 */
export interface GetDeliveryParcels200Response {
    /**
     * 
     * @type {GetDeliveryParcels200ResponseAllOfData}
     * @memberof GetDeliveryParcels200Response
     */
    data: GetDeliveryParcels200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetDeliveryParcels200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetDeliveryParcels200Response interface.
 */
export function instanceOfGetDeliveryParcels200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetDeliveryParcels200ResponseFromJSON(json: any): GetDeliveryParcels200Response {
    return GetDeliveryParcels200ResponseFromJSONTyped(json, false);
}

export function GetDeliveryParcels200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliveryParcels200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetDeliveryParcels200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetDeliveryParcels200ResponseToJSON(value?: GetDeliveryParcels200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetDeliveryParcels200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

